/**
 * Central game constants. Keep magic numbers out of scene code.
 */

export const GAME = {
  /** Design-time portrait resolution (9:16). Phaser scales to fit. */
  WIDTH: 1080,
  HEIGHT: 1920,
  ASPECT: 9 / 16,

  /** SpaceX blue, used for friendly units + HUD accents. */
  COLOR_FRIENDLY: 0x1d6bff,
  /** Void red, used for alien units. */
  COLOR_HOSTILE: 0xff2040,
  /** Neutral ink. */
  COLOR_INK: 0xffffff,
  COLOR_BG: 0x050505,
  COLOR_LINE: 0x1a1a1e,

  /** Battle Front: 5 strategic defense lanes. */
  LANE_COUNT: 5,

  /** Terafab: +1 Compute per minute of accumulated real time. */
  COMPUTE_PER_TICK: 1,
  COMPUTE_TICK_MS: 60_000,

  /** Reward for linking an off-world identity (email). */
  BACKUP_REWARD: 500,
} as const;

export const STATE_KEYS = {
  COMPUTE: 'compute',
  LAST_TICK: 'terafab.lastTickMs',
  BACKUP_CLAIMED: 'backup.claimed',
} as const;

export type SceneKey = 'BootScene' | 'PreloadScene' | 'CommandHubScene' | 'BattleFrontScene' | 'UIOverlayScene';
